import script from "./ReservationFinal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationFinal.vue?vue&type=script&setup=true&lang=js"

import "./ReservationFinal.vue?vue&type=style&index=0&id=45840540&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45840540"]])

export default __exports__